var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('award-write-link',{attrs:{"writeLayout":_vm.writeLayout,"competitionKey":_vm.competitionKey,"competitionPrize":_vm.competitionPrize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }